import { Component, OnInit, AfterViewInit, Inject } from "@angular/core";
import { Router, NavigationEnd, ActivatedRoute } from "@angular/router";
import { CookieService } from "ngx-cookie-service";
import { LanguageService } from "../../core/services/language.service";

import { EventService } from "../../core/services/event.service";
import { AuthenticationService } from "../../core/services/auth.service";
import { AuthfakeauthenticationService } from "../../core/services/authfake.service";

import { DOCUMENT } from "@angular/common";

import { MENU } from "./menu";
import { MenuItem } from "./menu.model";
import { environment } from "../../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { FormBuilder } from "@angular/forms";
import * as squel from "squel";

@Component({
  selector: "app-horizontaltopbar",
  templateUrl: "./horizontaltopbar.component.html",
  styleUrls: ["./horizontaltopbar.component.scss"],
})

/**
 * Horizontal Topbar and navbar specified
 */
export class HorizontaltopbarComponent implements OnInit, AfterViewInit {
  element;
  cookieValue;
  flagvalue;
  countryName;
  valueset;
  user;
  loggedUserName;
  loggedUserCompany;
  loggedUserImage;
  loggedUserPermisions;
  defautImage = "../../../../assets/images/noimage.png";

  menuItems = [];

  menuItem: boolean = false;
  menuOrder: boolean = false;
  menuInvoice: boolean = false;
  menuSoa: boolean = false;
  menuPayment: boolean = false;
  menuMessage: boolean = false;

  listLang = [
    { text: "English", flag: "assets/images/flags/us.jpg", lang: "en" },
    { text: "Spanish", flag: "assets/images/flags/spain.jpg", lang: "es" },
    { text: "German", flag: "assets/images/flags/germany.jpg", lang: "de" },
    { text: "Italian", flag: "assets/images/flags/italy.jpg", lang: "it" },
    { text: "Russian", flag: "assets/images/flags/russia.jpg", lang: "ru" },
  ];

  // tslint:disable-next-line: max-line-length
  constructor(
    @Inject(DOCUMENT) private document: any,
    private router: Router,
    private eventService: EventService,
    private authService: AuthenticationService,
    private authFackservice: AuthfakeauthenticationService,
    public languageService: LanguageService,
    // tslint:disable-next-line: variable-name
    public _cookiesService: CookieService,
    private http: HttpClient
  ) {
    router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.activateMenu();
      }
    });
  }

  ngOnInit(): void {
    this.element = document.documentElement;
    this.getLoggedUser(this._cookiesService.get("loggedPersonId"));
    this.initialize();

    this.cookieValue = this._cookiesService.get("lang");
    const val = this.listLang.filter((x) => x.lang === this.cookieValue);
    this.countryName = val.map((element) => element.text);
    if (val.length === 0) {
      if (this.flagvalue === undefined) {
        this.valueset = "assets/images/flags/us.jpg";
      }
    } else {
      this.flagvalue = val.map((element) => element.flag);
    }
    document.body.classList.remove("right-bar-enabled");
  }

  setLanguage(text: string, lang: string, flag: string) {
    this.countryName = text;
    this.flagvalue = flag;
    this.cookieValue = lang;
    this.languageService.setLanguage(lang);
  }

  getLoggedUser(id) {
    if (id) {
      const query = squel
        .select()
        .from("user_details")
        .where("user_details.id  = ?", id);

      this.http
        .post(environment.service_query_url + "/data", {
          sql: query.toString(),
        })
        .subscribe((data: any) => {
          if (data.success === true) {
            console.log("getCustomer())=>", data.result[0]);
            this.user = data.result[0];
            console.log(this.user);
            this.loggedUserName = this.user.name;
            this.loggedUserPermisions = JSON.parse(this.user.permission);
            this.setPermissionForMenu(this.loggedUserPermisions);
            let tmploggedUserCompany = JSON.parse(this.user.branches);
            this.getUserCompany(tmploggedUserCompany[0]);
            if (this.user.photo_url) {
              this.loggedUserImage =
                "../../../../assets/images/users/User-avatar.svg";
            } else {
              this.loggedUserImage = this.defautImage;
            }
          }
        });
    }
  }

  setPermissionForMenu(permissionArray) {
    if (permissionArray.includes(1)) {
      this.menuItem = true;
    }
    if (permissionArray.includes(2)) {
      this.menuOrder = true;
    }
    if (permissionArray.includes(3)) {
      this.menuInvoice = true;
    }
    if (permissionArray.includes(4)) {
      this.menuSoa = true;
    }
    if (permissionArray.includes(5)) {
      this.menuPayment = true;
    }
    if (permissionArray.includes(11)) {
      this.menuMessage = true;
    }
  }

  getUserCompany(id) {
    const query = squel.select().from("customer").where("customer.id  = ?", id);

    this.http
      .post(environment.service_query_url + "/data", { sql: query.toString() })
      .subscribe((data: any) => {
        if (data.success === true) {
          console.log("getCustomer())=>", data.result[0].name);
          this.loggedUserCompany = data.result[0].name;
        }
      });
  }

  /**
   * Logout the user
   */
  logout() {
    if (environment.defaultauth === "firebase") {
      this.authService.logout();
    } else {
      this.authFackservice.logout();
    }
    this._cookiesService.delete("loggedPersonId");
    this.router.navigate(["/auth/login"]);
  }

  /**
   * On menu click
   */
  onMenuClick(event) {
    const nextEl = event.target.nextElementSibling;
    if (nextEl) {
      const parentEl = event.target.parentNode;
      if (parentEl) {
        parentEl.classList.remove("show");
      }
      nextEl.classList.toggle("show");
    }
    return false;
  }

  ngAfterViewInit() {
    this.activateMenu();
  }

  /**
   * remove active and mm-active class
   */
  _removeAllClass(className) {
    const els = document.getElementsByClassName(className);
    while (els[0]) {
      els[0].classList.remove(className);
    }
  }

  /**
   * Togglemenu bar
   */
  toggleMenubar() {
    const element = document.getElementById("topnav-menu-content");
    element.classList.toggle("show");
  }

  /**
   * Activates the menu
   */
  private activateMenu() {
    const resetParent = (el: any) => {
      const parent = el.parentElement;
      if (parent) {
        parent.classList.remove("active");
        const parent2 = parent.parentElement;
        this._removeAllClass("mm-active");
        this._removeAllClass("mm-show");
        if (parent2) {
          parent2.classList.remove("active");
          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.remove("active");
            const parent4 = parent3.parentElement;
            if (parent4) {
              parent4.classList.remove("active");
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.remove("active");
                const menuelement = document.getElementById(
                  "topnav-menu-content"
                );
                if (menuelement !== null)
                  if (menuelement.classList.contains("show"))
                    document
                      .getElementById("topnav-menu-content")
                      .classList.remove("show");
              }
            }
          }
        }
      }
    };

    // activate menu item based on location
    const links = document.getElementsByClassName("side-nav-link-ref");
    let matchingMenuItem = null;
    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < links.length; i++) {
      // reset menu
      resetParent(links[i]);
    }
    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < links.length; i++) {
      // tslint:disable-next-line: no-string-literal
      if (location.pathname === links[i]["pathname"]) {
        matchingMenuItem = links[i];
        break;
      }
    }

    if (matchingMenuItem) {
      const parent = matchingMenuItem.parentElement;
      /**
       * TODO: This is hard coded way of expading/activating parent menu dropdown and working till level 3.
       * We should come up with non hard coded approach
       */
      if (parent) {
        parent.classList.add("active");
        const parent2 = parent.parentElement;
        if (parent2) {
          parent2.classList.add("active");
          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.add("active");
            const parent4 = parent3.parentElement;
            if (parent4) {
              parent4.classList.add("active");
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.add("active");
              }
            }
          }
        }
      }
    }
  }

  /**
   * on settings button clicked from topbar
   */

  /**
   * Fullscreen method
   */
  fullscreen() {
    document.body.classList.toggle("fullscreen-enable");
    if (
      !document.fullscreenElement &&
      !this.element.mozFullScreenElement &&
      !this.element.webkitFullscreenElement
    ) {
      if (this.element.requestFullscreen) {
        this.element.requestFullscreen();
      } else if (this.element.mozRequestFullScreen) {
        /* Firefox */
        this.element.mozRequestFullScreen();
      } else if (this.element.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        this.element.webkitRequestFullscreen();
      } else if (this.element.msRequestFullscreen) {
        /* IE/Edge */
        this.element.msRequestFullscreen();
      }
    } else {
      if (this.document.exitFullscreen) {
        this.document.exitFullscreen();
      } else if (this.document.mozCancelFullScreen) {
        /* Firefox */
        this.document.mozCancelFullScreen();
      } else if (this.document.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        this.document.webkitExitFullscreen();
      } else if (this.document.msExitFullscreen) {
        /* IE/Edge */
        this.document.msExitFullscreen();
      }
    }
  }

  /**
   * Topbar light
   */
  topbarLight() {
    document.body.setAttribute("data-topbar", "light");
    document.body.removeAttribute("data-layout-size");
    document.body.removeAttribute("data-layout-scrollable");
  }

  /**
   * Set boxed width
   */
  boxedWidth() {
    document.body.setAttribute("data-layout-size", "boxed");
    document.body.setAttribute("data-topbar", "dark");
    document.body.removeAttribute("data-layout-scrollable");
  }

  /**
   * Colored header
   */
  coloredHeader() {
    document.body.setAttribute("data-topbar", "colored");
    document.body.removeAttribute("data-layout-size");
    document.body.removeAttribute("data-layout-scrollable");
  }

  scrollable() {
    document.body.removeAttribute("data-layout-size");
    document.body.setAttribute("data-layout-scrollable", "true");
  }

  /**
   * Change the layout onclick
   * @param layout Change the layout
   */
  changeLayout(layout: string) {
    this.eventService.broadcast("changeLayout", layout);
  }

  /**
   * Initialize
   */
  initialize(): void {
    this.menuItems = MENU;
  }

  /**
   * Returns true or false if given menu item has child or not
   * @param item menuItem
   */
  hasItems(item: MenuItem) {
    return item.subItems !== undefined ? item.subItems.length > 0 : false;
  }
}
